<template>
    <div class="wgCalcSteps">
        <component :is="'Step'+$storage.state.currentStep.key.capitalize()" ref="component"/>
        <div class="wgCalcSteps__navigation" v-if="this.stepIndex !== this.$storage.state.steps.length-1">
            <v-btn
                rounded
                large
                color="primary"
                v-if="stepIndex==0"
                class="ml-auto"
                @click="onNext"
                :disabled=" !this.$storage.state.isValid"
            >
                {{ $t('begin') }}
            </v-btn>
            <v-btn
                rounded
                large
                color="light"
                v-if="stepIndex >0"
                @click="onBack"
            >
                {{$t('back')}}
            </v-btn>
            <v-btn
                rounded
                large
                color="primary"
                v-if="stepIndex >0 && stepIndex < this.$storage.state.steps.length-2"
                @click="onNext"
                :disabled=" !this.$storage.state.isValid"
            >
                {{$t('next')}}
            </v-btn>
            <v-btn
                rounded
                large
                color="primary"
                 v-if="stepIndex==this.$storage.state.steps.length-2"
                @click="onNext"
                :disabled=" !this.$storage.state.isValid"
            >
                {{$t('order')}}
            </v-btn>
        </div>
    </div>
</template>
<script>
import StepAddress from "./steps/StepAddress";
import StepRoofSize from "./steps/StepRoofSize";
import StepRoofType from "./steps/StepRoofType";
import StepProducts from "./steps/StepProducts";
import StepSummary from "./steps/StepSummary";
import StepSuccess from "./steps/StepSuccess";

export default {
    name:'StepsWrap',
    components:{
        StepAddress,
        StepRoofSize,
        StepRoofType,
        StepProducts,
        StepSummary,
        StepSuccess
    },
    data(){
        return {
        }
    },
    computed:{
        stepIndex(){
            return this.$storage.state.steps.indexOf(this.$storage.state.currentStep);
        }


    },
    methods:{
        onNext(){
            if(this.$refs.component.isValid){
                this.$refs.component.applyNext()
            }
        },
        onBack(){
            this.$storage.state.currentStep = this.$storage.state.steps[this.stepIndex-1];
        }
    }
}
</script>
<style lang="scss">
.wgCalc{
    &Steps{
        width: 100%;
        flex-grow: 1;
        display: flex;
        > div:first-child{
            width: 100%;
            position: relative;
            flex-grow: 1;
            overflow: hidden;
            grid-template-rows: 1fr;
            grid-template-columns: 1fr 1fr;
            display: flex;
            flex-direction: column-reverse;
            @media screen and (min-width: 756px){
                display: grid;
            }

        }

        &__navigation{
            width: 100%;
            height: 80px;
            display: flex;
            flex-direction: row;
            -webkit-box-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            align-items: center;
            padding: 1rem;
            box-shadow: rgb(0 0 0 / 10%) 0px 2px 20px;
            position: absolute;
            bottom: 0px;
            right: 0px;
            z-index: 3;
            background: rgb(255, 255, 255);
            @media screen and (min-width: 756px){
                width: 50%;
            }
        }

    }
}
</style>
